"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "What type of water pump do I need?",
    answer:
      "The right pump depends on your water source, application, required flow rate, pumping head, delivery distance and available power source. For example, submersible pumps can be suitable for certain submerged applications, while surface, petrol or diesel pumps may be more appropriate for other installations.",
  },
  {
    question: "How do I know what size water pump I need?",
    answer:
      "You need to determine the required flow rate and total pumping head, while also considering the water source, elevation, pipework and delivery requirements. Horsepower alone is not enough to determine the correct pump size.",
  },
  {
    question: "Can a water pump be used for irrigation?",
    answer:
      "Yes. Water pumps can be used for agricultural and irrigation applications, but the appropriate pump depends on factors such as the water source, irrigation method, required flow, distance and elevation.",
  },
  {
    question: "Do water pumps require regular maintenance?",
    answer:
      "Yes. Regular inspection and servicing can help maintain reliable operation and identify issues before they cause significant downtime. Engine-driven pumps require engine servicing, while other components such as seals, bearings and impellers may also require inspection or replacement depending on the pump.",
  },
];

export default function WaterPumpFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="w-full py-16 lg:py-24 px-4">
      <div className="text-center mb-12 lg:mb-16">
        <h2 className="lg:text-4xl text-2xl font-bold text-primary">
          Water Pump Solutions FAQs
        </h2>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-3 lg:gap-4">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={faq.question}
              className="border border-gray-200 rounded-lg overflow-hidden bg-white"
            >
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left p-5 lg:p-6"
              >
                <span className="lg:text-lg font-bold text-primary">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 flex-shrink-0 text-primary transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`grid transition-all duration-200 ease-in-out ${
                  isOpen
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-sm lg:text-base text-gray-600 px-5 lg:px-6 pb-5 lg:pb-6">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}